import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Typewriter from 'typewriter-effect';
import Header from '../Header/Header';
import './Home.css';

const Home = () => {

    return (
        <div className="home-container py-4">
            <Container>
                <Header />
                <div className="home-info">
                    <Row>
                        <Col xs={12} md={6}>
                            <div className="d-flex justify-content-center">
                                <div className="">
                                    <div className="text-white my-info ps-3 mb-3">
                                        <p className="pb-0 mb-0">Hello I'm</p>
                                        <h1 className="pt-0 mt-0">Md Hayatul Islam</h1>
                                        <h5>
                                            <Typewriter
                                                options={{
                                                    strings: ['Javascript Developer', 'React Developer', 'Full-Stack Developer', 'MERN Stack Developer'],
                                                    autoStart: true,
                                                    loop: true,
                                                }}
                                            />
                                        </h5>
                                        <div className="social-media pt-4">
                                            <a target="_blank" className="text-white" href="https://github.com/hayatul-islam"><i className="fab fa-github"></i></a>
                                            <a target="_blank" className="text-white" href="https://www.linkedin.com/in/hayatul-islam/"><i className="fab fa-linkedin-in"></i></a>
                                            <a target="_blank" className="text-white" href="https://web.facebook.com/hayatul.emon/"><i className="fab fa-facebook"></i></a>
                                            <a target="_blank" className="text-white" href="https://twitter.com/EmonHayatul"><i className="fab fa-twitter"></i></a>
                                        </div>

                                    </div>
                                    <div className="pt-5">
                                        <a target="_blank" href="https://drive.google.com/file/d/1ls2nf4TPup-FmWwZCPkrREDhdJBF5IxQ/view?usp=sharing">
                                            <button className="btn btn-info px-5 py-3 rounded-pill"><i className="far fa-arrow-alt-circle-down"></i> Download Resume</button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={6}>
                            <div className="text-center pt-5">
                                <img src="https://i.ibb.co/P5wwmWK/back.png" alt="" />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default Home;

{/* <img src="https://i.ibb.co/P5wwmWK/back.png" alt="" /> */ }
{/* <Col lg={2}>
<div className="pt-5 mt-5">
    <img className="my-image" src="https://i.ibb.co/TTdRGgq/154430617-158613409426730-7427306624905219817-n.jpg" alt="" />
</div>
</Col> */}